import type React from 'react';
import type { MouseEvent } from 'react';

import { Backdrop, Dialog as BaseDialog, type DialogProps as BaseDialogProps } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import * as styles from './styles';
import type { DialogSizes, OverflowTypes } from './utils';

import { ContainerDefault } from '../../Containers';
import { backgrounds } from '../../styles';

export interface DialogProps extends BaseDialogProps {
  maxWidth?: DialogSizes;
  overflowY?: OverflowTypes;
  onClose?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const StyledBackdrop = withStyles({
  root: {
    backgroundColor: backgrounds.modal.modalScrimBackground,
  },
})(Backdrop);

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Dialog: React.FC<DialogProps> = (props) => {
  const closeOnClick = props.onClose ? undefined : props.onClose;

  const { classes, overflowY, ...otherProps } = props;

  return (
    <BaseDialog
      BackdropComponent={StyledBackdrop}
      PaperComponent={ContainerDefault}
      onClose={closeOnClick}
      classes={{
        ...classes,
        root: `${styles.root} ${classes ? classes.root : ''}`,
        scrollBody: `${styles.scrollBody} ${classes ? classes.scrollBody : ''}`,
        paper: `${styles.dialog(props.maxWidth || 'sm', props.scroll, overflowY)} ${classes?.paper ? classes.paper : ''}`,
      }}
      {...otherProps}
    >
      {props.children}
    </BaseDialog>
  );
};
